import type { PaymentReason, PaymentReasonType } from '~features/annals';
import type { PaywallTexts } from '~hooks/useMessageProcessing';

export enum PaymentType {
	Neurons = 'neurons',
	Subscription = 'premium',
	BotSubscription = 'premium_dd',
}

export type TPaymentBaseConfig = {
	callback?: (isSuccess: boolean) => void;
	cost?: number;
	botName?: string;
	reason: PaymentReason;
	reasonType: PaymentReasonType;
	paymentType?: PaymentType;
	defaultPromocode?: string;
	botClientId?: number | string;
};

export type TPaymentOpenConfig = TPaymentBaseConfig & {
	title?: string;
};

export type TPaymentConfig = TPaymentBaseConfig & {
	prefer?: 'subscription' | 'neurons';
	texts?: PaywallTexts;
};

export type TPaywallContext = {
	isOpenPaymentForm: boolean;
	reason?: PaymentReason;
	reasonType?: PaymentReasonType;
	defaultPromocode?: string;
	botClientId?: number | string;
	openPaywall: (arg: TPaymentConfig) => () => void;
};
